import { useCallback } from 'react';
import { toast } from '@/hooks/ui/use-toast';

/**
 * Custom hook for standardized error handling in shift components
 */
export const useShiftErrorHandler = () => {
  const handleError = useCallback((action: string, error: unknown) => {
    console.error(`Error ${action}:`, error);
    
    const errorMessage = error instanceof Error 
      ? error instanceof Error ? error.message : String(error) 
      : 'An unexpected error occurred';
    
    toast.error(`Failed to ${action}`, { description: errorMessage });
  }, []);

  const handleSuccess = useCallback((message: string) => {
    toast.success(message);
  }, []);

  const handleWarning = useCallback((message: string) => {
    toast.warning(message);
  }, []);

  return {
    handleError,
    handleSuccess,
    handleWarning,
  };
};